import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetContactEnrichment as GetContactEnrichmentQuery,
    GetContactEnrichmentVariables as GetContactEnrichmentVariables,
    GetContactEnrichment_contactEnrichment as ContactEnrichment,
    ContactEnrichmentInput,
} from 'nutshell-graphql-types';

import GET_CONTACT_ENRICHMENT from '../queries/get-contact-enrichment.graphql';

export const useGetContactEnrichment = (
    input: ContactEnrichmentInput
): {
    contactEnrichment: ContactEnrichment | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetContactEnrichmentQuery,
        GetContactEnrichmentVariables
    >(GET_CONTACT_ENRICHMENT, {
        variables: {
            input,
        },
    });

    const contactEnrichment = data ? data.contactEnrichment : null;

    return {
        contactEnrichment,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
